import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { ActivityItemQuery as ActivityItemQueryType, ActivityItemQueryVariables } from "./__generated__/ActivityItemQuery";

const ActivityItemQuery = loader("./ActivityItemQuery.gql");

type ActivityItemQueryProviderType = (props: {
  children: (data: ActivityItemQueryType) => ReactNode;
  variables: ActivityItemQueryVariables;
}) => ReactElement;

export const ActivityItemQueryProvider: ActivityItemQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<ActivityItemQueryType, ActivityItemQueryVariables>(ActivityItemQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
